import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, Row, Col, Button } from 'reactstrap';
import { connect } from 'react-redux';
import * as actionsRedux from '../../../Store/Actions/index';
import InputForm from '../../Form/InputForm';
import SelectForm from '../../Form/SelectForm';
import { axiosApi } from '../../axiosInstances';
import NewLoader from '../../NewLoader';

const ModalAulasFaltantes = ({
    isOpen,
    setIsOpen,
    aulasFaltantes,
    dados,
    setModalConteudo,
    dadosModalConteudo,
    conteudoDisponivel
}) => {
    const style = {
        col4: { xs: 6, md: 3, sm: 3, lg: 3, xl: 3 },
        col6: { xs: 6, md: 2, sm: 2, lg: 2, xl: 2 }
    };

    const toggle = () => {
        if (dados?.semestre_tema != null) {
            setModalConteudo(true);
        }
        setIsOpen(!isOpen);
    };

    useEffect(() => {
    }, [isOpen]);

    return (
        <NewLoader overlay >
            <Modal isOpen={isOpen} toggle={toggle} size='xl'>
                <ModalHeader>
                    <h4>
                        <b>Aulas Não Alocadas</b>
                    </h4>
                    <h5>
                        {
                            dados?.semestre_tema != null ? (
                                <b>{dados?.semestre_tema?.[0]?.semestre_periodo_letivo?.periodo_letivo?.descricao} - {dados?.semestre_tema?.[0]?.tema?.semestre?.descricao} Semestre - {dados?.semestre_tema?.[0]?.semestre_periodo_letivo?.turma_id != null ? (dados?.semestre_tema?.[0]?.semestre_periodo_letivo?.turma?.descricao) : ""}</b>
                            ) : (
                                <b>{dados?.semestre_periodo_letivo?.periodo_letivo?.descricao} - {dados?.tema?.semestre?.descricao} Semestre - {dados?.semestre_periodo_letivo?.turma_id != null ? (dados?.semestre_periodo_letivo?.turma?.descricao + " - " + dados?.tema?.nome) : (dados?.tema?.nome)}</b>
                            )
                        }
                    </h5>
                </ModalHeader>
                <ModalBody>
                    {Array.isArray(aulasFaltantes) && aulasFaltantes.length > 0 ? (
                        <div style={{ width: '100%', maxWidth: 1000, margin: '0 auto', padding: '8px 0' }}>
                            <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 8, display: 'flex', borderBottom: '1px solid #e5e7eb', paddingBottom: 4 }}>
                                <div style={{ flex: 2 }}>Título</div>
                                <div style={{ flex: 1 }}>Tipo de Atividade</div>
                            </div>
                            {aulasFaltantes.map((aula, idx) => (
                                <div key={idx} style={{ display: 'flex', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid #f3f4f6', fontSize: 15 }}>
                                    <div style={{ flex: 2, wordBreak: 'break-word' }}>{aula.titulo}</div>
                                    <div style={{ flex: 1 }}>{aula.tipo_de_atividade?.nome}</div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="text-center text-muted py-4">Nenhuma aula faltante encontrada.</div>
                    )}
                    <Row>
                        <Col className="align-content-middle">
                            <Button className="mx-3 mb-6" onClick={() => toggle()}>Fechar</Button>
                        </Col>
                    </Row>
                </ModalBody>
            </Modal>
        </NewLoader>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        ativar: (tipo, acao) => dispatch(actionsRedux.ativarAlert(tipo, acao))
    };
};

export default connect(null, mapDispatchToProps)(ModalAulasFaltantes);
